import React from 'react';

function GuidedWaxTypeScreen({ hardWaxAddOns, otherAddOns, selectedAddOns, onToggleAddOn, parentServiceId, serviceName, onSkip }) {
  const formatPrice = (price) => price > 0 ? `+$${price}` : 'Free';

  // Has the user picked a hard wax upgrade? (if not, strip wax is the default)
  const hasHardWaxSelected = (hardWaxAddOns || []).some(hw =>
    selectedAddOns.some(a => a.id === hw.id && a.parentServiceId === parentServiceId)
  );

  function handleStripWaxSelect() {
    // Deselect any hard wax selections for this service
    (hardWaxAddOns || []).forEach(hw => {
      const isSelected = selectedAddOns.some(a => a.id === hw.id && a.parentServiceId === parentServiceId);
      if (isSelected) onToggleAddOn(hw, parentServiceId);
    });
  }

  function handleHardWaxSelect(addOn) {
    // Single-select among hard wax options: deselect others, then select this one
    (hardWaxAddOns || []).forEach(hw => {
      const isSelected = selectedAddOns.some(a => a.id === hw.id && a.parentServiceId === parentServiceId);
      if (isSelected && hw.id !== addOn.id) onToggleAddOn(hw, parentServiceId);
    });
    const alreadySelected = selectedAddOns.some(a => a.id === addOn.id && a.parentServiceId === parentServiceId);
    if (!alreadySelected) onToggleAddOn(addOn, parentServiceId);
  }

  return (
    <div className="guided-screen-content">
      {/* WAX TYPE SELECTION */}
      {(hardWaxAddOns || []).length > 0 && (
        <div className="guided-section">
          <div className="guided-section-header">Choose your wax</div>
          <div className="guided-yesno-grid">
            {/* Strip Wax — included, no add-on */}
            <button
              className={`guided-yesno-btn ${!hasHardWaxSelected ? 'guided-variant-selected' : ''}`}
              onClick={handleStripWaxSelect}
              aria-pressed={!hasHardWaxSelected}
            >
              <span className={`guided-card-indicator ${!hasHardWaxSelected ? 'checked' : ''}`} aria-hidden="true">
                {!hasHardWaxSelected && '✓'}
              </span>
              <div className="guided-yesno-label">Strip Wax</div>
              <div className="guided-yesno-sub">Traditional soft wax applied with a cloth strip</div>
              <div className="guided-variant-price guided-variant-price--included">Included</div>
            </button>

            {/* Hard Wax options */}
            {hardWaxAddOns.map(addOn => {
              const isSelected = selectedAddOns.some(a => a.id === addOn.id && a.parentServiceId === parentServiceId);
              const displayName = addOn.name?.replace(/\s*-\s*(Brazilian|Bikini|French|Full Leg|Half Leg|Underarm|Arm|Back|Chest|Brow|Lip|Chin|Face|Nose).*$/i, '') || addOn.name;
              return (
                <button
                  key={addOn.id}
                  className={`guided-yesno-btn ${isSelected ? 'guided-variant-selected' : ''}`}
                  onClick={() => handleHardWaxSelect(addOn)}
                  aria-pressed={isSelected}
                >
                  <span className={`guided-card-indicator ${isSelected ? 'checked' : ''}`} aria-hidden="true">
                    {isSelected && '✓'}
                  </span>
                  <div className="guided-yesno-label">{displayName}</div>
                  <div className="guided-yesno-sub">{addOn.description || 'Premium hard wax — gentler on sensitive areas'}</div>
                  <div className="guided-variant-price">{formatPrice(addOn.price)}</div>
                  {addOn.duration > 0 && <div className="guided-card-time">+{addOn.duration} min</div>}
                </button>
              );
            })}
          </div>
        </div>
      )}

      {/* OTHER OPTIONAL ADD-ONS */}
      {(otherAddOns || []).length > 0 && (
        <div className="guided-section">
          <div className="guided-section-header">Add-ons</div>
          <div className="guided-card-list">
            {otherAddOns.map(addOn => {
              const isSelected = selectedAddOns.some(a => a.id === addOn.id && a.parentServiceId === parentServiceId);
              return (
                <div
                  key={addOn.id}
                  className={`guided-card ${isSelected ? 'selected' : ''}`}
                  onClick={() => onToggleAddOn(addOn, parentServiceId)}
                >
                  <div className="guided-card-left">
                    <div className="guided-card-name">{addOn.name}</div>
                    {addOn.description && <div className="guided-card-desc">{addOn.description}</div>}
                  </div>
                  <div className="guided-card-right">
                    <div className="guided-card-meta">
                      {addOn.duration > 0 && <div className="guided-card-time">{addOn.duration} Mins</div>}
                      <div className="guided-card-price">{formatPrice(addOn.price)}</div>
                    </div>
                    <div className="guided-card-check">{isSelected ? '✓' : ''}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      <button className="guided-no-addons-btn" onClick={onSkip}>
        {(hardWaxAddOns || []).length > 0 ? 'STRIP WAX — NO ADD-ONS' : 'NO ADD-ONS NEEDED'}
      </button>
    </div>
  );
}

export default GuidedWaxTypeScreen;
